/** Enum for choosing sorting mode */
export enum SortMode {
  alphabetically = 'alphabetically',
  creationDate = 'creationDate',
  updatedDate = 'updatedDate',
}
